import React from 'react';
import { Modal, Button, Spinner, Alert, Form } from 'react-bootstrap';

const DialCapxModal = ({
  show,
  onHide,
  loading,
  dialCapxTable,
  onTableChange,
  onClear,
  onSave,
  title = "Calibração (DIAL1 / CAPX1)",
  dialCommand = "CALDIAL1",
  capxCommand = "CALCAPX1",
  hasChanges = true
}) => {
  const handleDialChange = (idx, value) => {
    const newTable = [...dialCapxTable];
    newTable[idx].caldial = value;
    onTableChange(newTable);
  };

  const handleCapxChange = (idx, value) => {
    const newTable = [...dialCapxTable];
    newTable[idx].calcapx = value;
    onTableChange(newTable);
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #1c4220 0%, #8fad15 100%)', border: 'none' }}>
        <Modal.Title style={{ color: 'white', fontWeight: 600, fontSize: '1.2rem' }}>
          <span style={{ fontSize: '1.5rem', marginRight: '8px' }}>📊</span>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ background: 'linear-gradient(to bottom, #1e293b 0%, #0f172a 100%)', color: '#e2e8f0', padding: '2rem' }}>
        <Alert variant="info" className="mb-4" style={{
          background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.15) 0%, rgba(59, 130, 246, 0.05) 100%)',
          border: '1px solid rgba(59, 130, 246, 0.3)',
          color: '#93c5fd',
          fontSize: '0.9rem',
          borderRadius: '8px',
          padding: '1rem'
        }}>
          <strong style={{ fontSize: '1rem' }}>ℹ️ Como usar:</strong>
          <p className="mb-0 mt-2">Edite os 10 pontos de calibração para <strong>{dialCommand}</strong> e <strong>{capxCommand}</strong>. Os campos vazios não serão enviados ao equipamento.</p>
        </Alert>

        <div style={{
          background: 'rgba(30, 41, 59, 0.5)',
          borderRadius: '12px',
          padding: '1.5rem',
          border: '1px solid rgba(71, 85, 105, 0.5)'
        }}>
          <div style={{ overflowX: 'auto' }}>
            <table style={{
              width: '100%',
              borderCollapse: 'separate',
              borderSpacing: '0 8px'
            }}>
              <thead>
                <tr>
                  <th style={{
                    width: '60px',
                    textAlign: 'center',
                    color: '#94a3b8',
                    fontSize: '0.75rem',
                    fontWeight: 500,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    paddingBottom: '12px'
                  }}>
                    Ponto
                  </th>
                  <th style={{
                    minWidth: '200px',
                    color: '#94a3b8',
                    fontSize: '0.75rem',
                    fontWeight: 500,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    paddingBottom: '12px',
                    paddingLeft: '8px'
                  }}>
                    <div style={{ color: '#8fad15', fontSize: '0.9rem', fontWeight: 600, marginBottom: '2px' }}>
                      {dialCommand}
                    </div>
                    <div style={{ color: '#64748b', fontSize: '0.7rem', fontWeight: 400 }}>Tabela Dial</div>
                  </th>
                  <th style={{
                    minWidth: '200px',
                    color: '#94a3b8',
                    fontSize: '0.75rem',
                    fontWeight: 500,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    paddingBottom: '12px',
                    paddingLeft: '8px'
                  }}>
                    <div style={{ color: '#8fad15', fontSize: '0.9rem', fontWeight: 600, marginBottom: '2px' }}>
                      {capxCommand}
                    </div>
                    <div style={{ color: '#64748b', fontSize: '0.7rem', fontWeight: 400 }}>Capacitância</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {dialCapxTable.map((row, idx) => (
                  <tr key={idx} style={{ marginBottom: '8px' }}>
                    <td style={{
                      textAlign: 'center',
                      verticalAlign: 'middle',
                      fontWeight: 700,
                      color: '#cbd5e1',
                      fontSize: '1.1rem',
                      background: 'rgba(71, 85, 105, 0.3)',
                      borderRadius: '8px 0 0 8px',
                      padding: '12px 8px'
                    }}>
                      {row.idx}
                    </td>
                    <td style={{
                      padding: '4px 8px',
                      background: 'rgba(30, 41, 59, 0.5)'
                    }}>
                      <Form.Control
                        type="number"
                        step="any"
                        value={row.caldial}
                        onChange={e => handleDialChange(idx, e.target.value)}
                        placeholder={`Ex: ${(10 + idx * 5).toFixed(1)}`}
                        title={`Envia: ${dialCommand}:${row.idx}:valor`}
                        style={{
                          background: 'rgba(15, 23, 42, 0.8)',
                          border: '2px solid rgba(71, 85, 105, 0.5)',
                          color: '#e2e8f0',
                          fontSize: '1rem',
                          padding: '10px 12px',
                          borderRadius: '6px',
                          transition: 'all 0.2s ease',
                          fontWeight: 500
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = '#8fad15';
                          e.target.style.boxShadow = '0 0 0 3px rgba(143, 173, 21, 0.1)';
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = 'rgba(71, 85, 105, 0.5)';
                          e.target.style.boxShadow = 'none';
                        }}
                      />
                    </td>
                    <td style={{
                      padding: '4px 8px',
                      background: 'rgba(30, 41, 59, 0.5)',
                      borderRadius: '0 8px 8px 0'
                    }}>
                      <Form.Control
                        type="number"
                        step="any"
                        value={row.calcapx}
                        onChange={e => handleCapxChange(idx, e.target.value)}
                        placeholder={`Ex: ${(15 + idx * 3).toFixed(1)}`}
                        title={`Envia: ${capxCommand}:${row.idx}:valor`}
                        style={{
                          background: 'rgba(15, 23, 42, 0.8)',
                          border: '2px solid rgba(71, 85, 105, 0.5)',
                          color: '#e2e8f0',
                          fontSize: '1rem',
                          padding: '10px 12px',
                          borderRadius: '6px',
                          transition: 'all 0.2s ease',
                          fontWeight: 500
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = '#8fad15';
                          e.target.style.boxShadow = '0 0 0 3px rgba(143, 173, 21, 0.1)';
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = 'rgba(71, 85, 105, 0.5)';
                          e.target.style.boxShadow = 'none';
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

      </Modal.Body>
      <Modal.Footer style={{ background: '#0f172a', border: 'none', padding: '1.25rem' }}>
        <Button
          variant="outline-secondary"
          onClick={onHide}
          disabled={loading}
          style={{ fontWeight: 500, padding: '8px 20px' }}
        >
          Cancelar
        </Button>
        <Button
          variant="outline-danger"
          onClick={onClear}
          disabled={loading}
          style={{ fontWeight: 500, padding: '8px 20px' }}
        >
          🗑️ Limpar Tudo
        </Button>
        <Button
          onClick={onSave}
          disabled={loading || !hasChanges}
          style={{
            opacity: (!hasChanges && !loading) ? 0.5 : 1,
            background: hasChanges ? 'linear-gradient(135deg, #8fad15 0%, #6d8711 100%)' : '#6c757d',
            border: 'none',
            fontWeight: 600,
            padding: '8px 24px',
            boxShadow: hasChanges ? '0 4px 6px rgba(143, 173, 21, 0.3)' : 'none'
          }}
        >
          {loading ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Salvando...
            </>
          ) : (
            <>💾 Salvar</>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DialCapxModal;
